class ScrollTo extends HTMLElement {
  constructor() {
    super();
    this.observer = undefined;
    this.button = this.querySelector("button");
    this.target = document.getElementById(this.dataset.target);
    if (!this.target) return;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (this.observer) this.observer.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.add("hidden");
          } else {
            this.classList.remove("hidden");
          }
        });
      },
      {
        threshold: [1.0],
      }
    );
    this.observer.observe(this.target);
    this.button.addEventListener("click", this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    this.target.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "end",
    });
  }
}
customElements.define("scroll-to", ScrollTo);
